const enc = encodeURIComponent;
const qs = (params) => {
    const parts = Object.entries(params).filter(([, v]) => v !== undefined && v !== '' && v !== false).map(([k, v]) => `${k}=${enc(String(v))}`);
    return parts.length > 0 ? `?${parts.join('&')}` : '';
};
const path = (realm) => (realm === 'DRIVER' ? 'driver-suspensions' : 'rider-suspensions');
/** The operator's reputation surface. */
export class ReputationAdminApi {
    client;
    constructor(client) {
        this.client = client;
    }
    suspensions(realm, query) {
        return this.client.request({ method: 'GET', path: `/v1/ops/${path(realm)}${qs({ ...query })}`, auth: true });
    }
    suspend(realm, input) {
        return this.client.request({ method: 'POST', path: `/v1/ops/${path(realm)}`, body: input, auth: true });
    }
    lift(realm, suspensionId) {
        return this.client.request({ method: 'POST', path: `/v1/ops/${path(realm)}/${enc(suspensionId)}/lift`, body: {}, auth: true });
    }
    occurrenceReasons(country) {
        return this.client.request({ method: 'GET', path: `/v1/ops/occurrence-reasons${qs({ country })}`, auth: true });
    }
    saveOccurrenceReason(input) {
        return this.client.request({ method: 'PUT', path: '/v1/ops/occurrence-reasons', body: input, auth: true });
    }
    occurrences(query) {
        return this.client.request({ method: 'GET', path: `/v1/ops/occurrences${qs({ ...query })}`, auth: true });
    }
    answerOccurrence(marketId, occurrenceId, answer) {
        return this.client.request({ method: 'POST', path: `/v1/ops/occurrences/${enc(occurrenceId)}/answer`, body: { marketId, answer }, auth: true });
    }
    closeOccurrence(marketId, occurrenceId) {
        return this.client.request({ method: 'POST', path: `/v1/ops/occurrences/${enc(occurrenceId)}/close`, body: { marketId }, auth: true });
    }
    overview(query) {
        return this.client.request({ method: 'GET', path: `/v1/ops/relationships/overview${qs({ ...query })}`, auth: true });
    }
    blocks(query) {
        return this.client.request({ method: 'GET', path: `/v1/ops/relationships/blocks${qs({ ...query })}`, auth: true });
    }
    /** H1-RULES (D503, Q-136): an operator with `relationship:unblock` undoes a block with a written reason (3 … 300 characters); audited. */
    unblock(blockId, reason) {
        return this.client.request({ method: 'POST', path: `/v1/ops/relationships/blocks/${enc(blockId)}/unblock`, body: { reason }, auth: true });
    }
    recentRatings(query) {
        return this.client.request({ method: 'GET', path: `/v1/ops/ratings/recent${qs({ ...query })}`, auth: true });
    }
    tierLadder(marketId) {
        return this.client.request({ method: 'GET', path: `/v1/ops/driver-loyalty/ladder${qs({ marketId })}`, auth: true });
    }
}
/** The rider's or the driver's own reputation surface (the realm of the session decides which routes answer). */
export class ReputationPersonApi {
    client;
    realm;
    constructor(client, realm) {
        this.client = client;
        this.realm = realm;
    }
    standing() {
        return this.client.request({ method: 'GET', path: `/v1/${this.realm}/standing`, auth: true });
    }
    rideRelationship(rideId) {
        return this.client.request({ method: 'GET', path: `/v1/${this.realm}/rides/${enc(rideId)}/relationship`, auth: true });
    }
    /** Favorite (a rider, after a completed ride) or block the other party of the ride. */
    setRelationship(rideId, input) {
        return this.client.request({ method: 'POST', path: `/v1/${this.realm}/rides/${enc(rideId)}/relationship`, body: input, auth: true });
    }
    occurrenceReasons(rideId) {
        return this.client.request({ method: 'GET', path: `/v1/${this.realm}/rides/${enc(rideId)}/occurrence-reasons`, auth: true });
    }
    reportOccurrence(rideId, input) {
        return this.client.request({ method: 'POST', path: `/v1/${this.realm}/rides/${enc(rideId)}/occurrences`, body: input, auth: true });
    }
    occurrences(rideId) {
        return this.client.request({ method: 'GET', path: `/v1/${this.realm}/rides/${enc(rideId)}/occurrences`, auth: true });
    }
}
//# sourceMappingURL=reputation.js.map